import React from "react";
import nextId from "react-id-generator";
import { useHistory } from "react-router";
import { MainContext } from "../../DashboardContext/Context";

export default function HomeSidebar({ handleClick, type }) {
  const history = useHistory();
  const [currentList, setCurrentList] = React.useState([]);
  const context = React.useContext(MainContext);
  const { userDetails, updateState } = context;

  React.useEffect(() => {
    switch (type) {
      case "institute":
        setCurrentList([...homeListInstitute]);
        break;

      default:
        userDetails
          ? setCurrentList([...homeList])
          : setCurrentList([...homeListNotLogged]);
        break;
    }
  }, []);
  return (
    <div className="home-sidebar-main">
      {currentList.map((obj) => (
        <ul key={obj.keyId}>
          {obj.list.map((x) => (
            <li onClick={() => handleClick(x)} key={x.keyId}>
              {x.name}
            </li>
          ))}
        </ul>
      ))}
    </div>
  );
}
const homeListInstitute = [
  {
    keyId: nextId(),
    list: [
      {
        keyId: nextId(),
        name: "Dashboard",
        id: "dashboard",
      },
      {
        keyId: nextId(),
        name: "Profile",
        id: "profile",
      },
    ],
  },
  {
    keyId: nextId(),
    list: [
      { keyId: nextId(), name: "jobs List", id: "jobs-list" },
      { keyId: nextId(), name: "Saved Application", id: "saved-application" },
    ],
  },
  {
    keyId: nextId(),
    list: [
      {
        keyId: nextId(),
        name: "Notification",
        id: "notify",
      },
    ],
  },
  {
    keyId: nextId(),
    list: [
      {
        keyId: nextId(),
        name: "Help",
        id: "help",
      },
      {
        keyId: nextId(),
        name: "Feedback",
        id: "feedback",
      },
      {
        keyId: nextId(),
        name: "Terms & Condition",
        id: "tc",
      },
      {
        keyId: nextId(),
        name: "Privacy Policy",
        id: "policy",
      },
    ],
  },
  {
    keyId: nextId(),
    list: [
      {
        keyId: nextId(),
        name: "Log Out",
        id: "logout",
      },
    ],
  },
];
const homeList = [
  {
    keyId: nextId(),
    list: [
      {
        keyId: nextId(),
        name: "My Dashboard",
        id: "dashboard",
      },
      {
        keyId: nextId(),
        name: "My Profile",
        id: "profile",
      },
    ],
  },
  {
    keyId: nextId(),
    list: [
      { keyId: nextId(), name: "Recommended Jobs", id: "recommended-jobs" },
      { keyId: nextId(), name: "Saved Jobs", id: "saved-jobs" },
      { keyId: nextId(), name: "Applied Jobs", id: "applied-jobs" },
    ],
  },
  {
    keyId: nextId(),
    list: [
      {
        keyId: nextId(),
        name: "Notification",
        id: "notify",
      },
    ],
  },
  {
    keyId: nextId(),
    list: [
      {
        keyId: nextId(),
        name: "Help",
        id: "help",
      },
      {
        keyId: nextId(),
        name: "Feedback",
        id: "feedback",
      },
      {
        keyId: nextId(),
        name: "Terms & Condition",
        id: "tc",
      },
      {
        keyId: nextId(),
        name: "Privacy Policy",
        id: "policy",
      },
    ],
  },
  {
    keyId: nextId(),
    list: [
      {
        keyId: nextId(),
        name: "Log Out",
        id: "logout",
      },
    ],
  },
];
const homeListNotLogged = [
  // {
  //   keyId: nextId(),
  //   list: [
  //     {
  //       keyId: nextId(),
  //       name: "My Dashboard",
  //       id: "dashboard",
  //     },
  //     {
  //       keyId: nextId(),
  //       name: "My Profile",
  //       id: "profile",
  //     },
  //   ],
  // },
  // {
  //   keyId: nextId(),
  //   list: [
  //     { keyId: nextId(), name: "Recommended Jobs", id: "recommended-jobs" },
  //     { keyId: nextId(), name: "Saved Jobs", id: "saved-jobs" },
  //     { keyId: nextId(), name: "Applied Jobs", id: "applied-jobs" },
  //   ],
  // },
  // {
  //   keyId: nextId(),
  //   list: [
  //     {
  //       keyId: nextId(),
  //       name: "Notification",
  //       id: "notify",
  //     },
  //   ],
  // },
  {
    keyId: nextId(),
    list: [
      {
        keyId: nextId(),
        name: "Help",
        id: "help",
      },
      {
        keyId: nextId(),
        name: "Feedback",
        id: "feedback",
      },
      {
        keyId: nextId(),
        name: "Terms & Condition",
        id: "tc",
      },
      {
        keyId: nextId(),
        name: "Privacy Policy",
        id: "policy",
      },
    ],
  },
  {
    keyId: nextId(),
    list: [
      {
        keyId: nextId(),
        name: "Log In",
        id: "login",
      },
    ],
  },
];
